<template>
  <div class="primary-skills">
    <div class="title h-outer-border around-4 bw2 bz0 h-bg brown-2">
      <div class="label">英雄属性</div>
      <div class="tools">
        <div class="btn h-title nowrap" data-title="将所有属性点设为最大值" v-click-sound-button @click="handleFillMax">点满</div>
        <div class="btn h-title nowrap" data-title="将所有属性点设为 0" v-click-sound-button @click="handleFillMin">清空</div>
      </div>
      <div class="info">
        属性点数：{{ totalPoint }}
      </div>
    </div>
    <div class="primary-skills-box h-outer-border around-4 bw2 bz0 h-bg brown-2">
      <div class="primary-skill-item h-outer-border around-4 bw2 bz0 h-bg brown-2"
           v-for="item in psKills">
        <div class="skill-icon h-outer-border around-4 bw2 bz0">
          <img :src="`${$rHost}/img/ui/${psIconMap[item]}.jpg`" alt="">
        </div>
        <div class="skill-info flex">
          <div class="name">{{ psKillsNameCn[item] }}</div>
          <div class="input-value flex">
            <div class="mini-btn minus"
                 v-click-sound-button
                 :disabled="config[item] <= 0"
                 @click="handleMinusPSP(item)">-
            </div>
            <div class="value">
              <input type="text" maxlength="2" :value="config[item]" @blur="handleLimitPSP($event,item)">
            </div>
            <div class="mini-btn"
                 v-click-sound-button
                 :disabled="config[item] >= MAX_PS"
                 @click="handleAddPSP(item)">+
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  const MAX_PS = 99

  export default {
    name: 'PrimarySkills',

    data () {
      return {
        MAX_PS,
        psKills: [
          'attack',
          'defense',
          'power',
          'knowledge',
        ],
        psIconMap: {
          attack: 'PSKIL42A',
          defense: 'PSKIL42D',
          power: 'PSKIL42P',
          knowledge: 'KNOW',
        },
        psKillsNameCn: {
          attack: '攻击力',
          defense: '防御力',
          power: '力量',
          knowledge: '知识',
        },
        loading: false,
        config: {
          attack: 0,
          defense: 0,
          power: 0,
          knowledge: 0,
        },
      }
    },

    props: {
      initPrimarySkills: {
        type: Object,
        default () {
          return null
        }
      },
    },

    computed: {
      totalPoint () {
        const c = this.config
        return c.attack + c.defense + c.power + c.knowledge
      },
    },

    watch: {
      initPrimarySkills(d) {
        this.config = {
          attack: d?.a || 0,
          defense: d?.d || 0,
          power: d?.p || 0,
          knowledge: d?.k || 0,
        }
      }
    },

    mounted () {
    },

    methods: {
      getFormData () {
        return JSON.parse(JSON.stringify(this.config))
      },

      handleFillMin () {
        this.config = {
          attack: 0,
          defense: 0,
          power: 0,
          knowledge: 0,
        }
      },

      handleFillMax () {
        this.config = {
          attack: MAX_PS,
          defense: MAX_PS,
          power: MAX_PS,
          knowledge: MAX_PS,
        }
      },

      handleLimitPSP (e, prop) {
        let v = e.target.value
        if (!/^\d+$/.test(v)) {
          v = +(v).replace(/[^\d]/g, '') || 0
        }
        this.config[prop] = Math.max(0, Math.min(+v, MAX_PS))
        this.$forceUpdate()
      },

      async handleMinusPSP (prop) {
        this.config[prop] = Math.max(0, Math.min(this.config[prop] - 1, MAX_PS))
      },

      async handleAddPSP (prop) {
        this.config[prop] = Math.max(0, Math.min(this.config[prop] + 1, MAX_PS))
      },
    }
  }
</script>

<style lang="stylus" scoped>
  .primary-skills-box
    margin-top 2px
    padding 3px
    display flex
    justify-content space-between
    .primary-skill-item
      width 210px
      padding 3px
      display flex
      align-items center
      font-size 12px
      &:hover
        outline 1px solid $colorGold
        .mini-btn
          opacity 1

  .skill-icon
    width 60px
    height 60px
    padding 2px
    > img
      width 100%
      height 100%
      vertical-align top

  .skill-info
    width 144px
    flex-direction column
    padding 0 5px
    .name
      padding 0 5px
      line-height 24px
      font-size 14px
      letter-spacing 1px
      text-align center
      whiteText1()
    .input-value
      align-items center
      .value
        flex-grow 1
        text-align right
        whiteText1()
        input
          position relative
          width 100%
          height 24px
          padding 0 5px
          text-align center
          line-height 24px
          font-size 14px
          letter-spacing 1px

  .mini-btn
    opacity 0
    flex-shrink 0
    goldText1()
    z-index 1
    width 24px
    height 24px
    font-size 18px
    border 1px solid #78624a
    border-radius 2px
    line-height 22px
    text-align center
    background-color #392519
    user-select none
    &.minus
      line-height 20px
    &:hover
      cursor pointer
      border-color lighten(#78624a, 10%)
      color darken($colorGold, 30%)

  .mini-btn[disabled]
    filter grayscale(1)
    cursor not-allowed

  .primary-skills
    .title
      display flex
      align-items center
      margin-bottom 1px
      padding 2px 7px
      line-height 24px
      font-size 12px
      whiteText1()
      .label
        flex-grow 1
        letter-spacing 1px
        goldText()
      .info
        width 82px
        text-align right
        &:after
          width 150px

  .tools
    position relative
    padding 0 10px
    display flex
    .btn
      padding 0 2px
      line-height 24px
      letter-spacing 1px
      user-select none
      color $colorGold
      opacity 0.75
      &:not(:last-child)
        margin-right 5px
      &:hover
        opacity 1
        color $colorGold
        cursor pointer
      &:active
        opacity 1
        color darken($colorGold, 15%)

</style>
